/**
 * @author Akshay Kumar Singh
 * @file QuestionManagement Component
 * @flow
 */
import React, { useState, useEffect } from 'react';
import AlertModal from '../../shared/modals/AlertModal';
import { spinnerService } from '../../shared/services/spinner.service';
import { CallApi } from '../../shared/services/api.service'
import CONFIG from '../../configuration/config';
import { useHistory } from "react-router-dom";
import SubHeaderComponent from '../common/HeaderComponent/SubHeaderComponent';
import { setData, getData } from '../../shared/utils/storage.util';
import { LABLES, STRINGS } from '../../shared/constants/data';

const QuestionManagement = () => {
  const history = useHistory();
  const [state, setState] = useState({
    dataArr: [],
    typeArr: [],
    quesArr: [],
    type: LABLES.PreventativeMaintenance
  });

  /**
   * @description This function is react life cycle hook which sets initial values whenever the component loads.
   */
  useEffect(() => {
    getQuesData();
  }, [])

  /**
   * @description This function fetch all sub-questions data.
   */
  const getQuesData = async () => {
    spinnerService.show(LABLES.Oval, STRINGS.FetchSubQues);
    await CallApi(LABLES.POST, CONFIG.subTaskQues, {}, {}, '', getQuesList, history);
  }

  /**
   * @description SubTaskQues callback function
   * @param response This is the response structure received from API
   */
  const getQuesList = (response) => {
    if (response?.success) {
      setState({
        ...state,
        dataArr: response.response,
        quesArr: response.response[state.type],
        typeArr: Object.keys(response.response)
      })
      setData('quesList', response.response[state.type])
    }
  }

  /**
   * @description This function updates the value of questions in quesArr.
   */
  const handleDataChange = (event) => {
    const { quesArr } = state;
    const { id, name, value } = event.target;
    quesArr[id][name] = value
    setState({
      ...state,
      quesArr
    })
  }

  /**
   * @description This function updates the quesArr according to the selected type.
   */
  const handleChange = (event) => {
    event.preventDefault()
    const { id, name, value } = event.target;
    let check = checkEditable();
    if (check) {
      setState({
        ...state,
        [name]: value,
        quesArr: state.dataArr[value]
      })
      setData('quesList', state.dataArr[value])
    } else {
      AlertModal.showAlert(STRINGS.OperationAlertMsg)
    }
  }

  /**
   * @description This function turns the field editable.
   */
  const editData = (event, id) => {
    event.preventDefault();
    const { quesArr } = state;
    let check = checkEditable();
    if (check) {
      quesArr[id]['isEditable'] = true
      setState({
        ...state,
        quesArr
      })
    } else {
      AlertModal.showAlert(STRINGS.OperationAlertMsg)
    }
  }

  /**
   * @description This function check if the function is editable or not.
   */
  const checkEditable = () => {
    const { quesArr } = state;
    let check = true;
    quesArr.map((data, index) => {
      if (data?.isEditable === true) {
        check = false;
      }
    })
    return check;
  }

  /**
   * @description This function updates the value of sub-question and turn the field uneditable.
   */
  const handleUpdate = async (event, id) => {
    event.preventDefault();
    const { name, value } = event.target;
    const { quesArr, type } = state;
    if (!!quesArr[id]['ques']) {
      quesArr[id]['isEditable'] = false
      setState({
        ...state,
        quesArr
      })
      const dataObj = {
        ques: quesArr[id]['ques'],
        sub_ques_id: quesArr[id]['id']
      }
      spinnerService.show(LABLES.Oval, STRINGS.UpdateStaticQues);
      await CallApi(LABLES.POST, CONFIG.updateSubQues, {}, dataObj, '', updateSubQues, history);
    } else {
      AlertModal.showAlert(`Question is required in order to update static question of ${type}`);
    }
  }

  /**
   * @description updateSubQues callback function
   * @param response This is the response structure received from API
   */
  const updateSubQues = (response) => {
    if (response?.success) {
      AlertModal.showAlert(response?.message);
      setTimeout(() => {
        AlertModal.hideAlert();
        getQuesData();
      }, 2000);
    }
  }

  /**
   * @description This function restore data to its previous state
   */
  const restoreData = (event, id) => {
    event.preventDefault();
    let quesData = getData('quesList')
    const { quesArr } = state;
    if (id || id == 0) {
      quesArr[id] = quesData[id]
      setState({
        ...state,
        quesArr
      })
    }
  }

  return (
    <React.Fragment>
      <SubHeaderComponent page={2} pageName={LABLES.QuestionManagement} />
      <div className="super-admin">
        <label>{STRINGS.ListStaticQues}</label>
        <select className="form-control" name='type' onChange={handleChange} value={state.type} >
          <option value='' hidden>{STRINGS.SelectQuesType}</option>
          {state.typeArr.map((data, index) => {
            return (
              <option key={data} value={data} >
                {data}
              </option>
            )
          })}
        </select>
      </div>
      <div className="main-cntnt-wrap">
        <div className="container">
          <div className="plant-summary-wrapper">
            <div className="tasks-tabs">
              <div className="table-responsive">
                <table className="add-task-tble user-table">
                  <tbody>
                    <tr>
                      <th style={{ width: '10%' }}>{LABLES.SNo}</th>
                      <th style={{ width: '70%' }}>{LABLES.StaticQues}</th>
                      <th>{LABLES.Action}</th>
                    </tr>
                    {state.quesArr.map((data, index) => {
                      return (
                        <tr key={index} className={data.isEditable ? "row-editable" : ""}>
                          <td>{data?.sno}</td>
                          <td>
                            <input type="text" className="form-control" id={index} name='ques' onChange={handleDataChange} value={data?.ques} readOnly={!data.isEditable} />
                          </td>
                          <td>
                            <a href="" onClick={(e) => editData(e, index)} hidden={data.isEditable}><img src={require("../../assets/images/edit-icon.png")} alt="edit-icon" /></a>
                            <button type='button' id={index} name='update' onClick={(e) => handleUpdate(e, index)} className={"btn-update"} hidden={!data.isEditable}><img src={require("../../assets/images/right-check.png")} alt="cancel-icon" /></button>
                            <a href="" onClick={(e) => restoreData(e, index)} hidden={!data?.isEditable}><img src={require("../../assets/images/cancel-icon.png")} alt="cancel-icon" /></a>
                          </td>
                        </tr>
                      )
                    })
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default QuestionManagement;